/* eslint-disable */
// @ts-nocheck

// Scripts used for video_overlay, which is used in video modues, blog modules and on index pages and posts using the video post format.
// This script is extracted from frontend-scripts to be used in Divi's Dynamic Assets system.
import { FITVIDS_CUSTOM_SELECTOR } from '../fitvids-functions/constants';
(function ($) {
  $(window).on('et_pb_init_modules', function () {
    window.et_pb_init_video_overlay = function () {
      // Document Ready
      $(() => {
        window.et_pb_play_overlayed_video = function ($play_video) {
          const $this = $play_video;
          const $video_image = $this.closest('.et_pb_video_overlay');
          const $wrapper = $this.closest('.et_pb_video, .et_main_video_container, .et_pb_video_wrap');
          let $video_iframe = $wrapper.find('iframe');
          const is_embedded = $video_iframe.length > 0;
          const is_fb_video = $wrapper.find('.fb-video').length;
          let video_iframe_src;
          let video_iframe_src_splitted;
          let video_iframe_src_autoplay;

          if (is_embedded) {
            if (is_fb_video && 'undefined' !== typeof $video_iframe[2]) {
              // Facebook uses three http/https/iframe
              $video_iframe = $($video_iframe[2]);
            }

            // Add autoplay parameter to automatically play embedded content when overlay is clicked
            video_iframe_src = $video_iframe.attr('src') || $video_iframe.attr('data-src');
            if (!video_iframe_src) {
              return;
            }
            video_iframe_src_splitted = video_iframe_src.split('?');

            if (video_iframe_src.indexOf('autoplay=') !== -1) {
              return;
            }

            if (typeof video_iframe_src_splitted[1] !== 'undefined') {
              video_iframe_src_autoplay = `${video_iframe_src_splitted[0]}?autoplay=1&${video_iframe_src_splitted[1]}`;
            } else {
              video_iframe_src_autoplay = `${video_iframe_src_splitted[0]}?autoplay=1`;
            }

            $video_iframe
              .attr({
                src: video_iframe_src_autoplay,
              })
              .removeAttr('data-src');

            // A click can precede the deferred iframe's IntersectionObserver callback.
            if (typeof $.fn.fitVids === 'function') {
              $wrapper.fitVids({ customSelector: FITVIDS_CUSTOM_SELECTOR });
            }
          } else {
            $wrapper.find('video').get(0).play();
          }

          $video_image.fadeTo(500, 0, function () {
            const $image = $(this);

            $image.css('display', 'none');
          });
        };

        $('body').on(
          'click',
          '.et_pb_post .et_pb_video_overlay, .et_pb_video .et_pb_video_overlay, .et_pb_video_wrap .et_pb_video_overlay',
          function () {
            const $this = $(this);

            et_pb_play_overlayed_video($this);

            return false;
          },
        );
        // Window resize
        $(window).resize(function () {});
      });
    };

    window.et_pb_init_video_overlay();
  });
})(jQuery);
